import { DELETE_ROOM_OVERLAY } from "shared/context/overlay/types"
import { useEvent } from "shared/lib/useEvent"
import { useOverlay } from "shared/lib/useOverlay"
import { Room } from "shared/types/Room"
import { ProjectPermissions } from "shared/types/__generated__/graphql"

import { ProjectPermissionType } from "entities/projects/types/ProjectPermissions"

interface UseRoomMultiActionHandlersArgs {
  projectID: string
  rooms: Room[]
  permissions: ProjectPermissions
  onAction?: () => void
}

export type FilteredRoomMultiActionHandlers = {
  onDelete: (() => void) | undefined
}

export function useRoomMultiActionHandlers({
  projectID,
  rooms,
  permissions
}: UseRoomMultiActionHandlersArgs): FilteredRoomMultiActionHandlers {
  const { openOverlay } = useOverlay(DELETE_ROOM_OVERLAY)

  const handleDelete = useEvent(() => {
    openOverlay({ projectID, roomsToDelete: rooms })
  })

  return {
    onDelete: permissions[ProjectPermissionType.EDIT] ? handleDelete : undefined
  }
}
